import _ from 'lodash';
import * as extendActionType from '../extendActionType';

export const CREATE_IMAGING = 'imagings/CREATE_IMAGING';
export const CREATE_IMAGING_REQUEST = 'imagings/CREATE_IMAGING_REQUEST';
export const SAVE_RESULTS = 'imagings/SAVE_RESULTS';
export const GET_IMAGINGS_LIST = 'imagings/GET_IMAGINGS_LIST';
export const GET_IMAGINGS_FOR_DROPDOWN = 'imagings/GET_IMAGINGS_FOR_DROPDOWN';
export const DELETE_IMAGING = 'imagings/DELETE_IMAGING';
export const EDIT_IMAGING = 'imagings/EDIT_IMAGING';
export const SHARE_IMAGING = 'imagings/SHARE_IMAGING';
export const UNSHARE_IMAGING = 'imagings/UNSHARE_IMAGING';
export const DELETE_ATTACHMENT = 'imagings/DELETE_ATTACHMENT';
export const IMAGING_REFERRAL_DIALOGS = 'imagings/IMAGING_REFERRAL_DIALOGS';
export const CREATE_IMAGING_REFERRAL = 'imagings/CREATE_IMAGING_REFERRAL';
export const EDIT_IMAGING_REFERRAL = 'imaging/EDIT_IMAGING_REFERRAL';
export const PAY_FOR_IMAGING_REFERRAL = 'imagings/PAY_FOR_IMAGING_REFERRAL';
export const SHARE_IMAGING_WITH_PATIENT = 'imagings/SHARE_IMAGING_WITH_PATIENT';

export function createImaging(encounterId, fields) {
    return {
        type: CREATE_IMAGING,
        httpRequest: {
            method: 'post',
            path: `/encounterImagings/${encounterId}`,
            data: fields,
        },
    };
}

export function shareImagingWithPatient(imagingId) {
    return {
        type: SHARE_IMAGING_WITH_PATIENT,
        httpRequest: {
            method: 'post',
            path: `/encounterImagings/share/with/patient/${imagingId}`,
        }
    }
}

export function payForImagingReferral(imagingReferralId, fields) {
    return {
        type: PAY_FOR_IMAGING_REFERRAL,
        httpRequest: {
            method: 'post',
            path: `/encounterImagings/pay/referral/${imagingReferralId}`,
            data: fields,
        },
    };
}

export function createImagingRequest(imagingReferralId, fields) {
    return {
        type: CREATE_IMAGING_REQUEST,
        httpRequest: {
            method: 'post',
            path: `/encounterImagings/create/request/${imagingReferralId}`,
            data: fields,
        },
    };
}

export function createImagingReferral(fields) {
    return {
        type: CREATE_IMAGING_REFERRAL,
        httpRequest: {
            method: 'post',
            path: '/encounterImagings/referral',
            data: fields,
        },
    };
}

export function editImagingReferral(fields, imagingReferralId) {
    return {
        type: EDIT_IMAGING_REFERRAL,
        httpRequest: {
            method: 'put',
            path: `/encounterImagings/referral/${imagingReferralId}`,
            data: fields,
        },
    };
}

export function deleteAttachment(imagingId, attachmentId) {
    return {
        type: DELETE_ATTACHMENT,
        httpRequest: {
            method: 'del',
            path: `encounterImagings/attachment/${imagingId}`,
            params: {
                attachmentId,
            },
        },
        imagingId,
        attachmentId,
    };
}

export function getImagingsForDropdown(search) {
    return {
        type: GET_IMAGINGS_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: '/encounterImagings/list/dropdown',
            params: {
                search: _.trim(search),
            },
        },
    };
}

export function editImaging(imagingId, fields) {
    return {
        type: EDIT_IMAGING,
        httpRequest: {
            method: 'put',
            path: `/encounterImagings/edit/${imagingId}`,
            data: fields,
        },
        fields,
        id: imagingId,
    };
}

export function saveResults(imagingId, files) {
    return {
        type: SAVE_RESULTS,
        httpRequest: {
            method: 'put',
            path: `/encounterImagings/upload/results/${imagingId}`,
            data: {
                files,
            },
        },
    };
}

export function getImagingsList(encounterId, {offset, limit}) {
    return {
        type: GET_IMAGINGS_LIST,
        httpRequest: {
            method: 'post',
            path: `/encounterImagings/list/${encounterId}`,
            data: {
                offset,
                limit,
            },
        },
        offset,
        limit,
    };
}

export function shareImaging(imagingId) {
    return {
        type: SHARE_IMAGING,
        httpRequest: {
            method: 'put',
            path: `/encounterImagings/share/${imagingId}`,
        },
        imagingId,
    };
}

export function unshareImaging(imagingId) {
    return {
        type: UNSHARE_IMAGING,
        httpRequest: {
            method: 'put',
            path: `/encounterImagings/unshare/${imagingId}`,
        },
        imagingId,
    };
}

export function deleteImaging(imagingId) {
    return {
        type: DELETE_IMAGING,
        httpRequest: {
            method: 'del',
            path: `/encounterImagings/${imagingId}`,
        },
        id: imagingId,
    };
}

export function showImagingReferralForms() {
    return {
        type: extendActionType.show(IMAGING_REFERRAL_DIALOGS),
    };
}

export function hideImagingReferralForms() {
    return {type: extendActionType.clean(IMAGING_REFERRAL_DIALOGS)};
}



// WEBPACK FOOTER //
// ./src/reducers/imaging/imagingActions.js